// Copyright (c) 2019 Deere & Company

import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';

const WarrantyStatusModalHeader = props =>
    <header>
        {
            <span>
                <FormattedMessage id='WARRANTY_COVERAGE'/><span> {props.pin}</span>
            </span>
        }
        <span
            className='close-modal-icon'
            onClick={props.onCloseButtonClick}
        />
    </header>;

WarrantyStatusModalHeader.displayName = 'WarrantyStatusModalHeader';
WarrantyStatusModalHeader.propTypes = {
    onCloseButtonClick: PropTypes.func.isRequired,
    pin: PropTypes.string,
    warrantiesLength: PropTypes.number
};

export default WarrantyStatusModalHeader;



// WEBPACK FOOTER //
// ./src/shared/components/warranty-status-modal/warranty-status-modal-header.js